// extracted by mini-css-extract-plugin
export default {"NumberInput":"NumberInput_NumberInput__YN9sf"};